import React, { useMemo } from 'react';

import { Link } from 'react-router-dom';

import { CardContent, Grid, Typography } from '@mui/material';

import { IconFileAnalytics } from '@tabler/icons';

import { gridSpacing } from 'store/constant';

import MainCard from 'ui-component/cards/MainCard';
import RoundIconCard from 'ui-component/cards/RoundIconCard';
import { logsEnviroment } from 'config';

export default function LogsPage() {
    const availableLogs = useMemo(() => Object.keys(logsEnviroment), []);

    return (
        <MainCard
            title={
                <Grid container>
                    <Grid item>
                        <Typography variant="h2" sx={{ fontWeight: 700 }}>
                            Event History
                        </Typography>
                    </Grid>
                </Grid>
            }
        >
            <CardContent sx={{ p: 0 }}>
                <Grid container spacing={gridSpacing}>
                    {availableLogs?.map((item) => (
                        <Grid item xs={12} lg={4} sm={6}>
                            <Link to={`/history/${item}`}>
                                <RoundIconCard
                                    primary={item}
                                    secondary=""
                                    content={`${item} History Events`}
                                    iconPrimary={IconFileAnalytics}
                                    color="primary.main"
                                    bgcolor="primary.light"
                                />
                            </Link>
                        </Grid>
                    ))}
                </Grid>
            </CardContent>
        </MainCard>
    );
}
